document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('look-book-modal');
  const modalContent = document.getElementById('look-book-modal-content');
  const gridContainer = document.querySelector('.look-book-grid__container');
  const modalOverlay = modal.querySelector('.look-book-modal__overlay');
  const grid = document.getElementById('look-book-grid');

  let currentIndex = -1;

  if (grid && grid.classList.contains('look-book-grid--animate')) {
    grid.classList.add('is-visible');
  }

  function getLookItems() {
    return Array.from(document.querySelectorAll('.js-look-open'));
  }

  function openModal(index) {
    currentIndex = index;
    slideTo(index, 'next');

    setTimeout(() => {
      const scrollY = window.scrollY;
      modal.show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      modal.classList.add('active');
      // document.dispatchEvent(
      //   new CustomEvent('lookbookModal', {
      //     bubbles: true,
      //     detail: { modal: modalContent },
      //   }),
      // );
      gridContainer.classList.add('fade-out', 'is-hidden');
    }, 500);
  }

  function closeModal() {
    const dialog = document.getElementById('look-book-modal');

    dialog.classList.remove('active');

    setTimeout(() => {
      if (dialog.open) dialog.close();
      modalContent.innerHTML = '';
      currentIndex = -1;
      gridContainer.classList.remove('fade-out', 'is-hidden');
    }, 400);
  }

  function slideTo(index, direction = 'next') {
    const postId = getLookItems()[index]?.dataset.postId;
    const hiddenTemplate = document.getElementById(`look-${postId}`);
    if (!hiddenTemplate) return;

    // Remove all but the last article (if any) to prevent stacking
    const articles = modalContent.querySelectorAll('.look-book-article__container');
    if (articles.length > 1) {
      articles.forEach((el, idx) => {
        if (idx < articles.length - 1) el.remove();
      });
    }
    const currentArticle = modalContent.querySelector('.look-book-article__container');

    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = hiddenTemplate.innerHTML;
    const newArticle = tempWrapper.querySelector('.look-book-article__container');
    modalContent.appendChild(newArticle);

    // document.dispatchEvent(
    //   new CustomEvent('lookbookModal', {
    //     bubbles: true,
    //     detail: { modal: modalContent },
    //   }),
    // );

    const newImage = newArticle.querySelector('.look-book-article__image-slide');
    const newGrid = newArticle.querySelector('.look-book-article__product-grid-container .look-book-article__slide');
    const oldImage = currentArticle?.querySelector('.look-book-article__image-slide');
    const oldGrid = currentArticle?.querySelector('.look-book-article__product-grid-container .look-book-article__slide');

    const inClass = direction === 'next' ? 'slide-in-from-right' : 'slide-in-from-left';
    const outClass = direction === 'next' ? 'slide-out-to-left' : 'slide-out-to-right';

    [newImage, newGrid].forEach((el) => el?.classList.add(inClass));

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        [newImage, newGrid].forEach((el) => el?.classList.add('active-slide-in'));
        [oldImage, oldGrid].forEach((el) => el?.classList.add(outClass));
      });
    });

    setTimeout(() => {
      if (currentArticle && currentArticle !== newArticle) {
        modalContent.removeChild(currentArticle);
      }
      newArticle.style.position = 'relative';
      bindInjectedModalEvents();
    }, 400);
  }

  function showPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      slideTo(currentIndex, 'prev');
    }
  }

  function showNext() {
    if (currentIndex < getLookItems().length - 1) {
      currentIndex++;
      slideTo(currentIndex, 'next');
    }
  }

  function bindInjectedModalEvents() {
    modal.querySelector('.look-book-article__nav-arrow--left')?.addEventListener('click', showPrev);
    modal.querySelector('.look-book-article__nav-arrow--right')?.addEventListener('click', showNext);

    const closeLink = modal.querySelector('[data-close-modal]');
    closeLink?.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });

    const lookOpens = modal.querySelectorAll('.js-look-open');
    lookOpens.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const postId = this.dataset.postId;
        const index = getLookItems().findIndex((el) => el.dataset.postId === postId);
        if (index !== -1) openModal(index);
      });
    });
    if (typeof window.ProductItem === 'function') {
      window.ProductItem(modalContent);
    }
  }

  getLookItems().forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const postId = this.dataset.postId;
      const index = getLookItems().findIndex((el) => el.dataset.postId === postId);
      if (index !== -1) openModal(index);
    });
  });

  modalOverlay?.addEventListener('click', closeModal);

  // Keyboard support
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('active')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const modalContent = document.querySelector('.look-book-article__container');
  const articlePage = document.querySelector('.look-book-article__page');

  if (modalContent) {
    document.dispatchEvent(
      new CustomEvent('lookbookModal', {
        bubbles: true,
        detail: { modal: modalContent },
      })
    );
  }

  if (articlePage) {
    articlePage.classList.add('active');
  }
});

// Infinite scroll custom element
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init() {
    this.initInfiniteMode();
  }

  initInfiniteMode() {
    const trigger = this.querySelector('.js-infinite-scroll');
    if (!trigger) return;

    const triggerDistance = this.dataset.triggerDistance || '100px';

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadItems();
          }
        });
      },
      { rootMargin: triggerDistance }
    );

    this.observer.observe(trigger);
  }

  async loadItems() {
    if (this.isLoading) return;
    
    const nextUrl = this.querySelector('[data-next-url]').value;
    const currentPage = parseInt(this.querySelector('[data-current-page]').value);
    const totalPages = parseInt(this.querySelector('[data-total-pages]').value);

    if (currentPage >= totalPages) return;

    this.isLoading = true;
    this.setLoadingState(true);

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      this.appendNewItems(doc);
      this.updatePaginationData(doc);

      // Check if we've reached the end
      const newCurrentPage = parseInt(this.querySelector('[data-current-page]').value);
      const newTotalPages = parseInt(this.querySelector('[data-total-pages]').value);
      
      if (newCurrentPage >= newTotalPages) {
        this.remove();
      }

    } catch (error) {
      console.error('Failed to load more items:', error);
    } finally {
      this.isLoading = false;
      this.setLoadingState(false);
    }
  }

  appendNewItems(doc) {
    const gridSelector = this.dataset.gridSelector;
    const itemSelector = this.dataset.itemSelector;
    const uniqueAttribute = this.dataset.uniqueAttribute;
    const templateSelector = this.dataset.templateSelector;

    const targetGrid = document.querySelector(gridSelector);
    const newItems = doc.querySelectorAll(`${gridSelector} ${itemSelector}`);

    newItems.forEach(item => {
      const uniqueValue = item.getAttribute(uniqueAttribute.replace('data-', '')) || 
                         item.dataset[uniqueAttribute.replace('data-', '').replace(/-([a-z])/g, (g) => g[1].toUpperCase())];
      
      const exists = targetGrid.querySelector(`[${uniqueAttribute}="${uniqueValue}"]`);
      if (!exists) {
        targetGrid.appendChild(item.cloneNode(true));
      }
    });

    if (templateSelector) {
      const newTemplates = doc.querySelectorAll(templateSelector);
      newTemplates.forEach(template => {
        const templateId = template.id;
        if (!document.getElementById(templateId)) {
          document.body.appendChild(template.cloneNode(true));
        }
      });
    }
  }

  updatePaginationData(doc) {
    const responseData = doc.querySelector('.infinite-scroll__data');
    if (!responseData) return;

    const newNextUrl = responseData.querySelector('[data-next-url]').value;
    const newCurrentPage = responseData.querySelector('[data-current-page]').value;
    const newTotalPages = responseData.querySelector('[data-total-pages]').value;

    this.querySelector('[data-next-url]').value = newNextUrl;
    this.querySelector('[data-current-page]').value = newCurrentPage;
    this.querySelector('[data-total-pages]').value = newTotalPages;
  }

  setLoadingState(loading) {
  const spinner = this.querySelector('.js-infinite-scroll');
  if (spinner) {
    spinner.classList.toggle('loading', loading);
  }
}
}

// Register the custom element
customElements.define('infinite-scroll', InfiniteScroll);